import { all, call, put, takeEvery } from 'redux-saga/effects'
import api from '../../../services/api.services'
import {
  getCompanyEmployees,
  getCompanyEmployeesSuccess,
  getSpecificCompanyDashboard,
  getSpecificCompanyDashboardSuccess,
  setCompanyEmployees,
} from './DashboardActions'
import { Action } from 'redux-actions'
import {
  GetCompanyEmployees$Request,
  GetCompanyStatisticsByPeriod$Request,
  SetCompanyEmployees$Request,
} from '../../../services/api.types'
import { getErrorMsg } from '../../../common/helpers/translations'
import { INotification } from '../../../common/notifications/NotificationReducers'
import { addNotification, clearNotification } from '../../../common/notifications/NotificationActions'

function* sagaGetSpecificCompanyDashboard(action: Action<GetCompanyStatisticsByPeriod$Request>) {
  yield put({ type: String(clearNotification) })
  try {
    const { stats }: { stats: any } = yield call(api.statistics.getCompanyStatisticsByPeriod, action.payload)
    yield put({ type: String(getSpecificCompanyDashboardSuccess), payload: stats })
  } catch (e: any) {
    /*const content = e.message || getErrorMsg('get company statistics')
    const notification: INotification = {
      type: 'warning',
      content,
    }
    yield put({ type: String(addNotification), payload: notification })*/
  }
}

function* sagaGetCompanyEmployees(action: Action<GetCompanyEmployees$Request>) {
  yield put({ type: String(clearNotification) })
  try {
    const { employees } = yield call(api.users.getCompanyEmployees, action.payload)
    yield put({
      type: String(getCompanyEmployeesSuccess),
      payload: { employees, companyId: action.payload.companyId },
    })
  } catch (e: any) {
    console.log('sagaGetCompanyEmployees: ', e)
    /*const content = e.message || getErrorMsg('get employees')
    const notification: INotification = {
      type: 'warning',
      content,
    }
    yield put({ type: String(addNotification), payload: notification })*/
  }
}

function* sagaSetCompanyEmployees(action: Action<SetCompanyEmployees$Request & GetCompanyStatisticsByPeriod$Request>) {
  yield put({ type: String(clearNotification) })
  try {
    const { employees, companyId, month, period, startDate, endDate } = action.payload
    yield call(api.users.setCompanyEmployees, {
      employees,
      companyId,
      month,
    })
    yield put({
      type: String(getCompanyEmployeesSuccess),
      payload: {
        employees,
        companyId,
      },
    })
    // Refresh stats.
    yield put({
      type: String(getSpecificCompanyDashboard),
      payload: {
        companyId,
        period,
        startDate,
        endDate,
      },
    })
  } catch (e: any) {
    console.log('sagaSetCompanyEmployees: ', e)
    const content = e.message || getErrorMsg('set employees')
    const notification: INotification = {
      type: 'warning',
      content,
    }
    yield put({ type: String(addNotification), payload: notification })
  }
}

export function* dashboardSagas() {
  yield all([
    takeEvery(String(getSpecificCompanyDashboard), sagaGetSpecificCompanyDashboard),
    takeEvery(String(getCompanyEmployees), sagaGetCompanyEmployees),
    takeEvery(String(setCompanyEmployees), sagaSetCompanyEmployees),
  ])
}
